"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
var _interopRequireWildcard = require("reshow-runtime/helpers/interopRequireWildcard");
exports.__esModule = true;
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("reshow-runtime/helpers/objectSpread2"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("reshow-runtime/helpers/objectWithoutPropertiesLoose"));
var React = _interopRequireWildcard(require("react"));
var _classLib = require("class-lib");
var _reshowBuild = _interopRequireDefault(require("reshow-build"));
var _SemanticUI = _interopRequireDefault(require("../molecules/SemanticUI.js"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["component", "loading", "src", "imgProps", "prepend"]; // @ts-check
/**
 * @param {{
 *   component?: React.ReactNode,
 *   loading?: string,
 *   src?: string,
 *   imgProps?: any,
 *   prepend?: React.ReactNode | React.ReactNode[],
 *   className?: string,
 *   alt?: string,
 *   title?: string,
 *   atom?: string,
 *   children?: React.ReactNode | React.ReactNode[],
 *   [key: string]: any
 * }} props
 */
var Image = function Image(props) {
  var _props$component = props.component,
    component = _props$component === void 0 ? _SemanticUI["default"] : _props$component,
    _props$loading = props.loading,
    loading = _props$loading === void 0 ? "lazy" : _props$loading,
    src = props.src,
    imgProps = props.imgProps,
    prepend = props.prepend,
    restProps = (0, _objectWithoutPropertiesLoose2["default"])(props, _excluded);
  var alt = restProps.alt,
    title = restProps.title,
    atom = restProps.atom,
    children = restProps.children;
  var classes = (0, _classLib.mixClass)(props.className, {
    image: props.ui
  });
  var thisAlt = alt || title;
  var thisImgProps = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, imgProps), {}, {
    atom: "img",
    alt: thisAlt,
    key: src,
    src: src,
    loading: loading
  });
  restProps.className = classes;
  restProps.cssList = [{
    cssModule: ["image"],
    cssGroup: "semantic"
  }];
  if (atom && "img" !== atom) {
    return (0, _reshowBuild["default"])(component)(restProps, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [prepend, /*#__PURE__*/(0, _jsxRuntime.jsx)(_SemanticUI["default"], (0, _objectSpread2["default"])({}, thisImgProps)), children]
    }));
  } else {
    return (0, _reshowBuild["default"])(component)((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, restProps), thisImgProps));
  }
};
var _default = exports["default"] = Image;
module.exports = exports.default;